export const FileSizeUnit = {
  Byte: 'byte',
  Kilobyte: 'kilobyte',
  Megabyte: 'megabyte',
  Gigabyte: 'gigabyte',
  Terabyte: 'terabyte',
};

export const FileSizeUnitAbbreviation = {
  [FileSizeUnit.Byte]: 'b',
  [FileSizeUnit.Kilobyte]: 'kB',
  [FileSizeUnit.Megabyte]: 'MB',
  [FileSizeUnit.Gigabyte]: 'GB',
  [FileSizeUnit.Terabyte]: 'TB',
};

export const FILE_SIZE_FACTOR = 1024;

const FILE_SIZE_PRETTY_DECIMAL_PLACES = 2;

class FileSizeService {
  static getPrettyFileSize(size) {
    if (!size) {
      return this.#getPrettyFileSizeText(0, FileSizeUnitAbbreviation[FileSizeUnit.Byte]);
    }

    const unitIndex = Math.floor(Math.log(size) / Math.log(FILE_SIZE_FACTOR));

    const unitAbbreviations = [
      FileSizeUnitAbbreviation[FileSizeUnit.Byte],
      FileSizeUnitAbbreviation[FileSizeUnit.Kilobyte],
      FileSizeUnitAbbreviation[FileSizeUnit.Megabyte],
      FileSizeUnitAbbreviation[FileSizeUnit.Gigabyte],
      FileSizeUnitAbbreviation[FileSizeUnit.Terabyte],
    ];
    const unitAbbreviation = unitAbbreviations[unitIndex];
    const unitSize = (size / (FILE_SIZE_FACTOR ** unitIndex))
      .toFixed(FILE_SIZE_PRETTY_DECIMAL_PLACES) * 1;

    return this.#getPrettyFileSizeText(unitSize, unitAbbreviation);
  }

  static #getPrettyFileSizeText(unitSize, unitAbbreviation) {
    return `${unitSize} ${unitAbbreviation}`;
  }
}

export default FileSizeService;
